import { TABS_BY_CONTEXT } from "../tabs";

/**
 * Requirements §4.1: once inside, a product switcher moves between contexts
 * without going back to the landing.
 *
 * Tabs are not uniform across contexts (§4.3) — All has no Attention or
 * Transactions — so switching to a context that lacks the current tab falls
 * back to Overview rather than landing on an empty pane.
 */
const ContextSwitcher = ({
  context,
  contexts,
  tab = "overview",
  selector,
  granularity,
  t,
}) => {
  const safeContexts = contexts || [];
  const options =
    safeContexts.length > 1 ? [...safeContexts, "all"] : safeContexts;
  if (options.length < 2) return null;

  return (
    <nav className="toggle-options">
      {options.map((value) => {
        const nextTab = TABS_BY_CONTEXT[value].includes(tab) ? tab : "overview";
        const params = new URLSearchParams({
          context: value,
          tab: nextTab,
          selector: String(selector ?? 3),
          granularity: granularity || "month",
        });
        return (
          <a
            key={value}
            role="button"
            data-button-type={value === context ? "outline" : "text-white"}
            href={`/coaching-portal/income?${params.toString()}`}
          >
            <span>{t(`income.context.${value}`)}</span>
          </a>
        );
      })}
    </nav>
  );
};

export default ContextSwitcher;
